import './App.css'
import PdfCards from './PdfCards'

function App() {
  return (
    <>
      <h1>PDF Generation Benchmark</h1>
      <h4>The pdf generation benchmark is a tool that allows you to compare the performance of different pdf generation libraries on client side.</h4>
      <PdfCards />
    </>
  )
}

export default App
